import { render } from "./NotificationsDrawer.vue?vue&type=template&id=37d6cb6c"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=js"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__